import { emptyCreateModal } from "../../ScheduleStep/constants";

export const updateLargeFormatScheduleItems = largeFormatGroups => {
  largeFormatGroups.forEach(
    largeFormatItem =>
      (largeFormatItem.largeFormatCreateModal = emptyCreateModal)
  );
};

